
export class SlickData extends Array {

	getLength() {
		return this.length;
	}

}